import { Card, CardBody } from 'reactstrap'

const DefaultCard = ({ content }) => {
  return <Card style={{ height: '100%', marginBottom: 0 }}>{content}</Card>
}

export default DefaultCard
